import {networkDeviceConstants} from "../constants/network-device.constants";
import {networkDeviceService} from "../services/network-device.service";
import {toastr} from 'react-redux-toastr'
import i18next from "i18next";
import {exhibitionMapActions} from "./exhibition-map.actions";
import {history} from "../helpers/history";

const getNetworkDeviceList = () => {
    return dispatch => {
        dispatch({ type: networkDeviceConstants.NETWORK_DEVICE_LIST_REQUEST });
        networkDeviceService.getList()
            .then(
                networkDeviceModel => {
                    dispatch({ type: networkDeviceConstants.NETWORK_DEVICE_LIST_SUCCESS, networkDeviceModel } );
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LIST_FAILURE, error})
                }
        );
    };
};

const getNetworkDeviceById = (id) => {
    return dispatch => {
        dispatch( { type: networkDeviceConstants.NETWORK_DEVICE_BY_ID_REQUEST } );
            networkDeviceService.getItemById(id)
                .then(
                    networkDeviceModel => {
                        dispatch({type: networkDeviceConstants.NETWORK_DEVICE_BY_ID_SUCCESS, networkDeviceModel })
                    },
                    error => {
                        dispatch({type: networkDeviceConstants.NETWORK_DEVICE_BY_ID_ERROR, error })
                    }
                )
    }
};

const getNetworkDeviceSimpleInfo = (id) => {
    return dispatch => {
        dispatch({ type: networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_REQUEST});
        networkDeviceService.getSimpleInfo(id)
            .then(
                networkDeviceSimpleModel => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_SUCCESS, networkDeviceSimpleModel})
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_SIMPLE_MODEL_FAILURE, error })
                }
            );
    };
};


const getDropDownList = () => {
    return dispatch => {
        networkDeviceService.getDropdownList()
            .then(
                (dropdown) => {
                    console.log(dropdown);
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_DROPDOWN_LIST, dropdown})
                },
                err => {
                    toastr.error(i18next.t('status-error'), i18next.t('' ))
                }
            )
    }
}

const shutDownPc = (pcId) => {
    return dispatch => {
        networkDeviceService.shutdownPc(pcId)
            .then(
                () => {
                    dispatch(getNetworkDeviceList())
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
};

const powerOnPc = (pcId) => {
    return dispatch => {
        networkDeviceService.powerOnPc(pcId)
            .then(
                () => {
                    dispatch(getNetworkDeviceList())
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
}

const setDiagnosticMode = (networkDeviceId, diagnosticModeValue, reloadSimpleModel = false) => {
    return dispatch => {
        networkDeviceService.setDiagnosticMode(networkDeviceId, diagnosticModeValue)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    dispatch(exhibitionMapActions.getRooms());
                    if(reloadSimpleModel)
                        dispatch(getNetworkDeviceSimpleInfo(networkDeviceId))
                },
                error => {
                    console.log(error.message);
                    toastr.error(i18next.t('diagnostic-mode'), i18next.t('msg.diagnostic-mode-failure'));
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
};

const setIgnoreSchedule = (networkDeviceId, ignoreSchedule, reloadSimpleModel = false) => {
    return dispatch => {
        networkDeviceService.setIgnoreSchedule(networkDeviceId, ignoreSchedule)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    dispatch(exhibitionMapActions.getRooms());
                    if(reloadSimpleModel)
                        dispatch(getNetworkDeviceSimpleInfo(networkDeviceId))
                },
                error => {
                    console.log(error.message);
                    toastr.error(i18next.t('ignore-schedule'), i18next.t('msg.ignore-schedule-failure'));
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
}

const setAuditMode = (networkDeviceId, auditValue, reloadSimpleModel = false) => {
    return dispatch => {
        networkDeviceService.setAuditMode(networkDeviceId, auditValue)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    dispatch(exhibitionMapActions.getRooms());
                    if(reloadSimpleModel)
                        dispatch(getNetworkDeviceSimpleInfo(networkDeviceId))
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
};

const setDiagnosticModeAllDevices = (setValue) => {
    return dispatch => {
        networkDeviceService.setDiagnosticModeAllDevices(setValue)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    dispatch(exhibitionMapActions.getRooms());
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                    dispatch(getNetworkDeviceList());
                }
        )
    }
};

const createDevice = (networkDeviceModel) => {
    return dispatch => {
        networkDeviceService.addNetworkDevice(networkDeviceModel)
            .then(
                (res) => {
                    history.push(`/panel/network-device`);
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_VALIDATION_FORM, error});
                }
            )
    }
};

const editDevice = (networkDeviceModel) => {
    return dispatch => {
        networkDeviceService.editNetworkDevice(networkDeviceModel)
            .then(
                (res) => {
                    console.log(res);
                    history.push(`/panel/network-device`);
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LIST_FAILURE, error})
                }
            )
    }
};

const removeDeviceById = (networkDeviceId) => {
    return dispatch => {
        networkDeviceService.removeNetworkDevice(networkDeviceId)
            .then(
                () => {
                    dispatch(getNetworkDeviceList())
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                }
            )
    }
};

const restart = (networkDeviceId) => {
    return dispatch => {
        networkDeviceService.restart(networkDeviceId)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    toastr.info(i18next.t('network-device'), i18next.t('msg.reset-network-device', { id: networkDeviceId }))
                },
                error => {
                    console.log(error);
                }
            );
    }
};

const resynchronizeAll = (networkDeviceId) => {
    return dispatch => {
        dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LOADER_SHOW, msg: 'sync-all-msg' });
        networkDeviceService.resynchronizeAll(networkDeviceId)
            .then(
                () => {
                    dispatch(getNetworkDeviceList());
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LOADER_HIDE});
                },
                error => {
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_REMOVE_FAILURE, error})
                    dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LOADER_HIDE});
                }
            );
    }
};

const clearList = () => {
    return dispatch => {
        dispatch({type: networkDeviceConstants.NETWORK_DEVICE_LIST_CLEAR })
    };
};

const toggleAgentDeviceInfo = (toggleAction) => {
    return dispatch => {
        networkDeviceService.toggleAgentDeviceInfo(toggleAction)
            .then(
                () => {
                    toastr.info(i18next.t('network-device'), i18next.t('agent-device-info' ))
                },
                err=> {
                    toastr.error(i18next.t('status-error'), i18next.t('agent-device-info' ))
                }
            )
    }
}


export const networkDeviceActions = {
    getNetworkDeviceList,
    getNetworkDeviceById,
    getNetworkDeviceSimpleInfo,
    getDropDownList,
    createDevice,
    editDevice,
    removeDeviceById,
    clearList,
    shutDownPc,
    powerOnPc,
    restart,
    setDiagnosticMode,
    setIgnoreSchedule,
    setAuditMode,
    setDiagnosticModeAllDevices,
    resynchronizeAll,
    toggleAgentDeviceInfo,
};
